// extracted by mini-css-extract-plugin
export var link = "NavBarItem-module--link--jlTlE";
export var selected = "NavBarItem-module--selected--3dd-c";